module.exports = __webpack_public_path__ + "img/logoFarmapreciosOnline.edc53928.svg";